import React, { useState } from 'react';
import Grid from '@mui/material/Grid2';

import FileDropzone from "@components/input/FileDropzone";
import StringBox from "@components/input/strings/StringBox";
import CenteredMenu from "@components/input/menus/CenteredMenu";
import SelectStringBox from "@components/input/selects/SelectStringBox";

interface Props {
  name: string;
  image_url: string;
  select_options?: string[];
  onChange: (changed: string) => void;
}

export default function ImageInput({
  name,
  image_url,
  select_options,
  onChange,
}: Props) {
  const [mode, setMode] = useState(select_options ? "Select" : "URL");

  const onDrop = (acceptedFiles: File[]) => {
    console.log(acceptedFiles);
    if (acceptedFiles.length > 0) {
      const image = acceptedFiles[0];
      const data = new FormData();
      data.append("file", image);
      data.append("upload_preset", "o3zenvnq");
      data.append("cloud_name", "dojs5friw");
      fetch("https://api.cloudinary.com/v1_1/dojs5friw/image/upload", {
        method: "post",
        body: data
      })
        .then(resp => resp.json())
        .then(data => {
          onChange(data.url);
        })
        .catch(err => console.log(err));
    }
  }
  return (
    <Grid container spacing={0} direction="row">
      <Grid
        className="centered"
        size={{
          xs: 12
        }}>
        { image_url !== "" &&
          <img src={ image_url } alt={name}
            style={{
              maxWidth: "10em",
              maxHeight: "10em",
              border: "1px solid"
            }} 
          />
        }
      </Grid>
      <Grid
        size={{
          xs: 12
        }}>{name}</Grid>
      <Grid
        size={{
          xs: 12
        }}>
        <CenteredMenu
          options={ select_options && select_options.length > 0 ? ["URL","Select","Drag n Drop"] : ["URL","Drag n Drop"]}
          selected={mode}
          onSelect={setMode}
        />
      </Grid>
      { mode === "URL" ?
        <Grid
          size={{
            xs: 12
          }}>
          <StringBox
            name="Image URL"
            value={image_url}
            onBlur={onChange}
          />
        </Grid>
      : mode === "Select" && select_options ?
        <Grid
          size={{
            xs: 12
          }}>
          <SelectStringBox
            name="Select an Image"
            options={select_options}
            value={image_url}
            images
            onChange={onChange}
          />
        </Grid>
      : mode === "Drag n Drop" && 
        <Grid
          style={{ 
            padding: "0px"
          }}
          className="centered"
          size={{
            xs: 12
          }}>
          <FileDropzone 
            label={`Drag n drop new Image here` }
            accept={{'image/jpeg': [], 'image/png': []}} 
            onDrop={onDrop} 
          />
        </Grid>
      }
    </Grid>
  );
}
